import { v4 as uuidv4 } from 'uuid';
import Api from "../../../lib/api";
import ModalForm from "../../../components/base/forms/modal-form";
import Accordion from "../../../components/accordion";
import ReviewsSlider from "../../../components/reviews-slider";
import PhotoGallery from "../../../components/base/photo-gallery";
import {AnalyticsService} from "../../../services/analytics-service";

export default class PageModule {
	constructor() {
		this.initPhotoGallery();
		this.initReviewsSlider();
		this.initFaqSection();
		this.initForm();
	}
	initPhotoGallery() {
		const photoGallery = new PhotoGallery();
	}

	initReviewsSlider() {
		const reviewsSlider = new ReviewsSlider();
	}

	initFaqSection() {
		const accordion = new Accordion('accordion-faq');
	}

	initForm() {
		const $modalTriggers = document.querySelectorAll('[data-modal-trigger="gift-certificate"]');
		const $agreementLink = document.getElementById('contract-gift-link');
		const cityInfo = craft.env.cityInfo.find(({ id }) => id === Api.currentCityId);

		$agreementLink.href = cityInfo.citySwitchUrl + 'contract-gift';

		const form = new ModalForm({
			formId: 'gift-certificate',
			uri: '/1.0/gift/order',
			data: {
				referrer: location.href,
				fbp: costorage.get('_fbp') ? costorage.get('_fbp') : null,
				fbc: costorage.get('_fbc') ? costorage.get('_fbc') : null
			},
			$modalTriggers: [...$modalTriggers],
			hash: 'gift',
			subscriptions: [{
				event: 'beforeSubmit',
				callback: () => {
					const conversionId = uuidv4();
					const owoxUserId = costorage.get('ouid');

					form.addData({ conversionId });

					if (owoxUserId) {
						form.addData({ owoxUserId });
					}

					/* GTM Event */
					const dataLayerEventData = {
						event: 'gift_form',
						formId: form.formId,
						phone: form.data.tel,
						email: form.data.email,
						conversion_id: conversionId
					};

					const $formTitle = form.$root.querySelector('.form_title');

					if ($formTitle) {
						dataLayerEventData.formName = $formTitle.textContent;
					}

					AnalyticsService.sendEvent('gift_form', dataLayerEventData);
				}
			}]
		});
	}
}